module.exports = __webpack_public_path__ + "static/media/facebook-disabled-boosting.ffce9868.svg";